var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.rightsGroups, function (group, index) {
      return _c("div", { key: group.title }, [
        _c("div", [
          _c("div", { staticClass: "accordion-item accordionForm" }, [
            _c(
              "a",
              {
                staticClass: "item-content item-link",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    return _vm.rotateChevron($event)
                  },
                },
              },
              [
                _c("div", { staticClass: "item-inner" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "form-group row justify-content-start styleGeneral",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "item-title createInvoiceBand col-sm-auto",
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t(group.title)) +
                              "\n                "
                          ),
                          _c("i", { staticClass: "fa-light fa-chevron-down" }, [
                            _vm._v("chevron_right"),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "accordion-item-content" },
              _vm._l(group.lines, function (line) {
                return _c(
                  "div",
                  {
                    key: _vm.getLineKey(line),
                    staticClass: "form-group col-sm-12",
                  },
                  [
                    line.label
                      ? _c("div", [
                          _c("label", [_vm._v(_vm._s(_vm.$t(line.label)))]),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "pull-right",
                            attrs: {
                              type: "checkbox",
                              disabled: _vm.isDisabled(
                                _vm.getRightLabel(group.title, line.label)
                              ),
                            },
                            domProps: {
                              checked: _vm.isChecked(
                                _vm.getRightLabel(group.title, line.label)
                              ),
                            },
                            on: {
                              change: function ($event) {
                                _vm.rightChange(
                                  _vm.getRightLabel(group.title, line.label)
                                )
                              },
                            },
                          }),
                        ])
                      : _c("div", [
                          _c(
                            "div",
                            { staticClass: "accordion-item accordionForm" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "item-content item-link",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.rotateChevron($event)
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "item-inner" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group row justify-content-start styleGeneral",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "item-title createInvoiceBand col-sm-auto",
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(_vm.$t(line.title)) +
                                                "\n                        "
                                            ),
                                            _c(
                                              "i",
                                              {
                                                staticClass:
                                                  "fa-light fa-chevron-down",
                                              },
                                              [_vm._v("chevron_right")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(line.lines, function (groupLine) {
                                return _c(
                                  "div",
                                  {
                                    key: line.label,
                                    staticClass: "accordion-item-content",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group col-sm-12 pl-0 pr-0",
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(_vm.$t(groupLine.label))
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          staticClass: "pull-right",
                                          attrs: {
                                            type: "checkbox",
                                            disabled: _vm.isDisabled(
                                              _vm.getRightLabel(
                                                group.title,
                                                line.title,
                                                groupLine.label
                                              )
                                            ),
                                          },
                                          domProps: {
                                            checked: _vm.isChecked(
                                              _vm.getRightLabel(
                                                group.title,
                                                line.title,
                                                groupLine.label
                                              )
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.rightChange(
                                                _vm.getRightLabel(
                                                  group.title,
                                                  line.title,
                                                  groupLine.label
                                                )
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          index + 1 != _vm.rightsGroups.length ? _c("hr") : _vm._e(),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }